/* eslint-disable react/prop-types */
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, ModalBody, Spinner, Card, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { postApi } from "redux/action/api_tbeams";
import ReleasesTable from "./ReleasesTable";
import MemoReleaseTab from "./MemoReleaseTab";

export default function ReleaseCollection(props) {
  const { type } = props;
  const navigate = useNavigate();
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [form, setForm] = useState({
    date_from: "",
    date_to: "",
  });

  const location = useLocation();
  const isPending = location.pathname.includes("payapp");
  const [filter, setFilter] = useState(type || "All");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  return (
    <DashboardLayout>
      <MDBox pt={2} pb={3} pl={2} pr={2}>
        <Card style={{ minHeight: "80vh" }}>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="success"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h5" color="white">
              Release Collection
            </MDTypography>
          </MDBox>

          <Nav tabs style={{ marginLeft: 15, marginTop: 15, borderBottom: "2px solid #e0e0e0" }}>
            <NavItem>
              <NavLink
                active={activeTab === "1"}
                onClick={() => setActiveTab("1")}
                style={{
                  cursor: "pointer",
                  color: activeTab === "1" ? "#fff" : "#666",
                  backgroundColor: activeTab === "1" ? "#51ce5bff" : "transparent",
                  borderRadius: "8px 8px 0 0",
                  fontWeight: activeTab === "1" ? "bold" : "normal",
                  padding: "5px 20px",
                  border: activeTab === "1" ? "2px solid #bbb6d0ff" : "2px solid transparent",
                  borderBottom: activeTab === "1" ? "none" : "2px solid transparent",
                  marginBottom: "-2px",
                }}
              >
                Release Collection
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === "2"}
                onClick={() => setActiveTab("2")}
                style={{
                  cursor: "pointer",
                  color: activeTab === "2" ? "#fff" : "#666",
                  backgroundColor: activeTab === "2" ? "#51ce5bff" : "transparent",
                  borderRadius: "8px 8px 0 0",
                  fontWeight: activeTab === "2" ? "bold" : "normal",
                  padding: "5px 20px",
                  border: activeTab === "2" ? "2px solid #51cbce" : "2px solid transparent",
                  borderBottom: activeTab === "2" ? "none" : "2px solid transparent",
                  marginBottom: "-2px",
                }}
              >
                Recent Memos
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} style={{ padding: "20px" }}>
            <TabPane tabId="1">
              <ReleasesTable
                filterBy="approvals Reviewed"
                approval_status="Approval Initiated"
                reject_status=""
                title=""
                query_type={isPending ? "pending" : "by_filter"}
                return_status="Approval Initiated Returned"
                showButton={true}
              />
            </TabPane>
            <TabPane tabId="2">
              <MemoReleaseTab />
            </TabPane>
          </TabContent>
        </Card>
      </MDBox>

      <Modal isOpen={approvalLoading}>
        <ModalBody className="text-center">
          <Spinner />
          <h4>Please wait</h4>
        </ModalBody>
      </Modal>
    </DashboardLayout>
  );
}
